var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { convertToCSSValue, getGeometryStyle } from '../../helpers/styles';
var getBoxShadow = function (width) {
    var leftWidth = -1 * width;
    return convertToCSSValue(leftWidth) + " 0 0 " + convertToCSSValue(width) + " rgb(255, 255, 0);";
};
var StyledSlider = styled.input.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  overflow: ", ";\n  -webkit-appearance: ", ";\n  height: ", ";\n  background-color: ", ";\n\n  ::-webkit-slider-runnable-track {\n    height: ", ";\n    -webkit-appearance: ", ";\n    color: ", ";\n    margin-top: ", ";\n  }\n\n  ::-webkit-slider-thumb {\n    width: ", ";\n    -webkit-appearance: ", ";\n    height: ", ";\n    background: ", ";\n    box-shadow: ", ";\n    cursor: ", ";\n    border-width: ", ";\n    border-style: ", ";\n    border-left-color: ", ";\n    border-top-color: ", ";\n    border-right-color: ", ";\n    border-bottom-color: ", ";\n  }\n\n  ::-moz-range-progress {\n    background-color: rgb(255, 255, 0);\n  }\n  ::-moz-range-track {\n    background-color: rgb(43, 56, 86);\n  }\n  /* IE*/\n  ::-ms-fill-lower {\n    background-color: rgb(255, 255, 0);\n  }\n  ::-ms-fill-upper {\n    background-color: rgb(43, 56, 86);\n  }\n"], ["\n  ", ";\n\n  overflow: ", ";\n  -webkit-appearance: ", ";\n  height: ", ";\n  background-color: ", ";\n\n  ::-webkit-slider-runnable-track {\n    height: ", ";\n    -webkit-appearance: ",
    ";\n    color: ", ";\n    margin-top: ",
    ";\n  }\n\n  ::-webkit-slider-thumb {\n    width: ", ";\n    -webkit-appearance: ",
    ";\n    height: ", ";\n    background: ",
    ";\n    box-shadow: ", ";\n    cursor: ", ";\n    border-width: ",
    ";\n    border-style: ",
    ";\n    border-left-color: ",
    ";\n    border-top-color: ",
    ";\n    border-right-color: ",
    ";\n    border-bottom-color: ",
    ";\n  }\n\n  ::-moz-range-progress {\n    background-color: rgb(255, 255, 0);\n  }\n  ::-moz-range-track {\n    background-color: rgb(43, 56, 86);\n  }\n  /* IE*/\n  ::-ms-fill-lower {\n    background-color: rgb(255, 255, 0);\n  }\n  ::-ms-fill-upper {\n    background-color: rgb(43, 56, 86);\n  }\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.overflow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.appearance;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.runnableTrack.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.runnableTrack.appearance;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.runnableTrack.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.runnableTrack.marginTop;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.appearance;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.background;
}, function (_a) {
    var geometry = _a.geometry;
    return getBoxShadow(geometry.width);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.cursor;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.borderWidth;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.borderStyle;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.slider.sliderThumb.borderColor.bottom;
});
var Slider = function (props) {
    var _onFieldUpdate = useContext(WindowEventContext)._onFieldUpdate;
    var fields = useContext(WindowStateContext).fields;
    var identifier = props.identifier, attributes = props.attributes, form = props.form, _a = props.type, type = _a === void 0 ? 'text' : _a, onChange = props.onChange, children = props.children, windowId = props.windowId, restProps = __rest(props, ["identifier", "attributes", "form", "type", "onChange", "children", "windowId"]);
    var value = fields[identifier] || 0;
    var enabled = attributes.enabled, minimum = attributes.minimum, maximum = attributes.maximum, geometry = attributes.geometry;
    var disabled = enabled === 'false';
    var updateHandler = function (e) { return _onFieldUpdate(identifier, e.target.value); };
    return (React.createElement(StyledSlider, __assign({ type: "range", value: value, min: minimum, max: maximum, geometry: geometry, disabled: disabled, onInput: updateHandler }, restProps)));
};
export default Slider;
var templateObject_1;
//# sourceMappingURL=index.js.map